import React, { createContext, useContext, FC, Ref, useState, useRef, useEffect } from 'react';


export interface HeaderContext {
    triggerRef: Ref<HTMLDivElement>;
    isTriggerHide: boolean;
}

const Context = createContext({} as HeaderContext);

export const useHeaderContext = (): HeaderContext => useContext(Context);

export const HeaderProvider: FC<HeaderContext> = props => {
    const [isTriggerHide, setIsTriggerHide] = useState(false);
    const triggerRef = useRef(null);

    useEffect(() => {
        const currentTrigger = triggerRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0)
                    setIsTriggerHide(true);
                else
                    setIsTriggerHide(false);
            },
            { threshold: 0, rootMargin: '0px' },
        );

        if (currentTrigger)
            observer.observe(currentTrigger);

        return () => {
            if (currentTrigger)
                observer.unobserve(currentTrigger);
        };
    }, []);

    return <Context.Provider value={{ isTriggerHide, triggerRef }} {...props} />;
};
